import * as Sentry from "@sentry/browser";
import { Scope } from "@sentry/types";

type SentryParams = Parameters<typeof Sentry.captureException>;

export const logToSentry = (
  transactionName: string,
  exception: SentryParams[0],
  enhanceScope?: (scope: Scope) => Scope
) => {
  return Sentry.captureException(exception, scope => {
    scope.setTag("package", "payment");
    scope.setTransactionName(transactionName);
    scope.setExtra("error", exception);
    return enhanceScope?.(scope) ?? scope;
  });
};
